import { React, useEffect, useState, useContext } from "react";
import { initialInvoice } from "../data/initialData";
// import descriptions from "../data/descriptions";
import EditableInput from "./EditableInput";
import { Row, Button, Col, Container, Alert } from "react-bootstrap";
import Document from "./Document";
import Page from "./Page";
import View from "./View";
import Text from "./Text";
import EditableTextarea from './EditableTextarea'
import EditableSelect from './EditableSelect'
import ImageModal from "./AddReceipt";
import { FetchContext } from "../context/FetchContext";
import { AuthContext } from "../context/authContext";
import Confirm from "./Confirm";
import { applyFixedFeeOffset } from "../utils/fixedFeeOffset";



const Invoice = ({ user, data, pdfMode, onChange, btnSelect, setSaved, invShow, setLoad, descripts, setLastAction, fixedFeeContracts }) => {

  const auth = useContext(AuthContext);
  const cons = auth.authState.userInfo;
  const fetchContext = useContext(FetchContext);
  const [isLoading, setIsLoading] = useState(false)
  const [subTotal, setSubTotal] = useState();
  const [dupewarn, setDupeWarn] = useState(false)

  const [invoiceNumbers, setInvoiceNumbers] = useState([]);
  const [file, setFile] = useState([]);

  var today = new Date()
  let date = (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getFullYear();

  const descriptions = descripts;


  const reportable = [
    { value: '', text: "Select" },
    { value: "Reportable", text: "Yes" },
    { value: "Non-Reportable", text: "No" }
  ]


  const [lineItems, setLineItems] = useState([]);
  const [invoice, setInvoice] = useState(data ? Object.assign({}, data) : Object.assign({}, initialInvoice));
  const [alertMsg, setAlertMsg] = useState('');
  const [alertShow, setAlertShow] = useState(false);
  const [alertVari, setAlertVari] = useState('danger');


  function checkForm(mode = "draft") {
    // Base requirements (for both Draft and Submit)
    const hasValidProductDetails = invoice.lineItems.every((lt) => {
      const pt = (lt?.ProductType ?? "").trim();
      const productTypeValid =
        pt.length > 2 && pt !== "Select Product or Service";

      // Determine whether detail is required by looking up `descripts` first,
      // falling back to previous Travel Fee / Per Diem logic if unspecified.
      let detailIsRequired;
      try {
        const match = descripts?.find(
          (d) =>
            ((d?.value ?? "").toString().trim().toLowerCase()) === pt.toLowerCase()
        );
        if (match && typeof match.required === "boolean") {
          detailIsRequired = !!match.required;
        } else {
          detailIsRequired =
            pt !== "Travel Fee" && !pt.toLowerCase().includes("per diem");
        }
      } catch (e) {
        detailIsRequired =
          pt !== "Travel Fee" && !pt.toLowerCase().includes("per diem");
      }

      const detailValid =
        !detailIsRequired || ((lt?.ProductDetail ?? "").trim().length > 2);

      return productTypeValid && detailValid;
    });

    const baseValid =
      Array.isArray(invoice.lineItems) &&
      invoice.lineItems.length >= 1 &&
      !!invoice.Reportable &&
      !!invoice.ConsultantInvoice &&
      !!invoice.StartDate &&
      !!invoice.EndDate &&
      hasValidProductDetails &&
      !invoiceNumberError;

    if (!baseValid) return true; // invalid for both draft & submit

    if (mode === "submit") {
      // Must have a Location array with at least one entry
      const locArray = Array.isArray(invoice?.locations) ? invoice.locations : [];

      const allLocationsValid =
        locArray.length > 0 &&
        locArray.every(
          (loc) =>
            (loc?.city ?? "").trim().length > 0 &&
            (loc?.state ?? "").trim().length > 0
        );

      if (!allLocationsValid) return true; // invalid for submit
    }

    return false; // valid
  }


  useEffect(() => {
    setInvoice(data);
    fetchInvoiceNumbers();
  }, []);

  useEffect(() => {
    if (onChange) {
      onChange(invoice);
    }
  }, [onChange, invoice]);

  // Re-evaluate the fixed fee offset once contract data has loaded (covers opening an
  // existing draft that already has qualifying hours, not just live edits).
  useEffect(() => {
    if (Array.isArray(fixedFeeContracts) && fixedFeeContracts.length > 0) {
      setInvoice(prev => ({
        ...prev,
        lineItems: applyFixedFeeOffset(prev.lineItems || [], fixedFeeContracts, prev.StartDate)
      }));
    }
  }, [fixedFeeContracts]);

  useEffect(() => {
    let subTotal = 0;
    if (invoice.lineItems) {
      invoice.lineItems.forEach((lineItem) => {

        const quantityNumber = parseFloat(lineItem.quantity);
        const rateNumber = parseFloat(lineItem.rate);
        const amount = quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;
        subTotal += amount;
      });
    }
    subTotal = parseFloat(subTotal).toFixed(2)

    setSubTotal(subTotal);
    setInvoice(Object.assign(Object.assign({}, invoice), { subTotal }))
    checkDupe(invoice)
  }, [invoice.lineItems]);
  const [invoiceNumberError, setInvoiceNumberError] = useState(false);
  const handleChange = (name, value) => {
    // console.log("handleChange")
    // console.log(name)
    if (name !== 'lineItems') {
      const newInvoice = { ...invoice };

      if (name === 'ConsultantInvoice') {
        // Check for duplicate ConsultantInvoice number
        // console.log("Checking for duplicate ConsultantInvoice number:", value);

        // Normalize to array (handles both array or comma-separated string)
        const numbersArray = Array.isArray(invoiceNumbers)
          ? invoiceNumbers
          : invoiceNumbers.toString().split(",");

        // Case-insensitive exact match
        const isDuplicate = numbersArray.some(
          num => num.trim().toLowerCase() === value.trim().toLowerCase()
        );

        // console.log("Is duplicate:", isDuplicate);
        setInvoiceNumberError(isDuplicate);

        newInvoice[name] = value;
        setInvoice(newInvoice);
      } else if (name === 'EndDate') {
        const start = invoice.StartDate;
        const endDate = new Date(value);

        if (!start || (new Date(start) <= endDate)) {
          newInvoice[name] = value;
        } else {
          newInvoice[name] = ''; // Reset to blank if invalid
        }
        setInvoice(newInvoice);

      } else if (name === 'StartDate') {
        const end = invoice.EndDate;
        const startDate = new Date(value);

        if (!end || (startDate <= new Date(end))) {
          newInvoice[name] = value;
        } else {
          newInvoice[name] = ''; // Reset to blank if invalid
        }
        newInvoice.lineItems = applyFixedFeeOffset(invoice.lineItems, fixedFeeContracts, newInvoice.StartDate);
        setInvoice(newInvoice);

      } else if (name === 'logoWidth' && typeof value === 'number') {
        newInvoice[name] = value;
        setInvoice(newInvoice);

      } else if (name !== 'logoWidth' && typeof value === 'string') {
        newInvoice[name] = value;
        setInvoice(newInvoice);
      }
    }
  };

  function isDetailRequired(productType) {
    // prefer explicit descriptor flag from `descripts` if available
    try {
      const pt = (productType || '').toString().trim();
      const match = descripts?.find(d => (d?.value ?? '').toString().trim().toLowerCase() === pt.toLowerCase());
      if (match && typeof match.required === 'boolean') {
        return match.required;
      }
    } catch (e) {
      // fall back to default logic on error
    }

 
  }
  const handleProductLineChange = (index, name, value) => {
    console.log("handleProductLineChange");
    console.log(invoice);
    console.log(value);

    const isPerDiemType = (v = "") => /(^|\s)per\s*diem(\s|$)/i.test(v);

    const lineItems = invoice.lineItems.map((lineItem, i) => {
      if (i !== index) return { ...lineItem };

      const newLineItem = { ...lineItem }; // shallow copy

      if (name === "ProductType") {
        newLineItem[name] = value;

        // defaults
        newLineItem.rate = "0.00";
        newLineItem.unit = "";

        if (newLineItem.ProductType && newLineItem.ProductType.includes("Consultant")) {
          // Consultant logic (unchanged): pick billRate2 if billType2 matches; otherwise billRate
          if (
            invoice.rateInfo.billType2 &&
            newLineItem.ProductType.includes(invoice.rateInfo.billType2)
          ) {
            newLineItem.rate = invoice.rateInfo.billRate2
              ? Number(invoice.rateInfo.billRate2).toFixed(2)
              : "";
            newLineItem.unit = invoice.rateInfo.billType2 || "";
          } else {
            newLineItem.rate = invoice.rateInfo.billRate
              ? Number(invoice.rateInfo.billRate).toFixed(2)
              : "";
            newLineItem.unit = invoice.rateInfo.billType || "";
          }
        } else if (isPerDiemType(value) && Array.isArray(descripts)) {
          // ONLY assign from descripts when it's a Per Diem type; exact match on value
          const d = descripts.find((x) => x?.value === value);
          if (d) {
            const raw = d.price ?? d.Price;
            if (raw != null) {
              const num = parseFloat(String(raw).replace(/[^0-9.]/g, ""));
              if (!Number.isNaN(num)) newLineItem.rate = num.toFixed(2);
            }
            if (d.unit) newLineItem.unit = d.unit;
          }
        }
        // For non-Consultant & non-Per Diem types, leave "0.00" and "" as set above.
      } else if (name === "ProductDetail") {
        newLineItem[name] = value;
      } else if (name === "file") {
        if (value.length === 0) {
          newLineItem.base64Container = "";
          newLineItem.fileName = "";
        } else {
          newLineItem.base64Container = value[0].b64;
          newLineItem.fileName = value[0].fileName;
        }
      } else {
        // numeric fields
        let val = value.replace("$", "");
        if (
          val[val.length - 1] === "." ||
          (val[val.length - 1] === "0" && val.includes("."))
        ) {
          newLineItem[name] = val;
        } else {
          const n = parseFloat(val);
          newLineItem[name] = (n ? n : 0).toString();
        }
      }

      return newLineItem;
    });

    const finalLineItems = applyFixedFeeOffset(lineItems, fixedFeeContracts, invoice.StartDate);

    setInvoice({ ...invoice, lineItems: finalLineItems });
  };

  const handleFormat = (index, name, value) => {
    // console.log("handleFormat")
    // console.log(index)
    // console.log(name)
    // console.log(value)
    let val = value.replace('$', '')
    const lineItems = invoice.lineItems.map((lineItem, i) => {
      if (name === 'rate' && i === index && val.length > 0) {
        // console.log(lineItem)
        const newLineItem = Object.assign({}, lineItem);

        const isMileage = lineItem.ProductType && lineItem.ProductType.toLowerCase().includes('mileage');
        newLineItem[name] = parseFloat(val).toFixed(isMileage ? 3 : 2)

        return newLineItem;
      }
      return Object.assign({}, lineItem);
    });
    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems }));
    // console.log(invoice)



  };

  const handleRemoveLoc = (i, value) => {
    const locations = invoice.locations.filter((loc, index) => index !== i);
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }))
  };

  const handleRemove = (i) => {
    // console.log(i)
    const lineItems = invoice.lineItems.filter((lineItem, index) => index !== i);
    //console.log(lineItem)
    const finalLineItems = applyFixedFeeOffset(lineItems, fixedFeeContracts, invoice.StartDate);
    setLineItems(finalLineItems)
    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems: finalLineItems }))
  };

  function handleAdd() {
    const lineItems = [...invoice.lineItems, initialInvoice.lineItems[0]];
    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems }));
  };

  function handleLocationChange(index, name, value) {
    const locations = invoice.locations.map((loc, i) => {
      const newLoc = Object.assign({}, loc);;
      if (i === index) {
        newLoc[name] = value;

        return newLoc;
      }
      return loc;
    });
    // console.log(invoice.locations)
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }));
    // console.log(invoice)

  };

  function handleAddLoc() {
    // console.log("add location")
    const locations = [...invoice.locations, { "city": '', "state": '' }]
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }))
  }
  const calculateAmount = (quantity, rate) => {
    const quantityNumber = parseFloat(quantity);
    const rateNumber = parseFloat(rate);
    const amount = quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;
    return amount.toFixed(2);
  };

  async function handleDraft(e) {
    e.preventDefault();
    setAlertShow(false);
    setIsLoading(true);
    try {
      const res = await fetchContext.authAxios.post("/savedraft", invoice);
      if (res.data.message === 'Session Expired') {
        auth.logout();
      } else if (res.data.message === 'Success') {
        if (typeof setLastAction === "function") {
          setLastAction("draft");
        }
        setSaved();
        invShow();
      } else {
        throw new Error(res.data.message || 'Unexpected server response');
      }
    } catch (error) {
      console.log(error);
      setAlertMsg('There was an error saving your draft. Please try again.');
      setAlertVari('danger');
      setAlertShow(true);
    } finally {
      setIsLoading(false);
    }
  }


  async function handleSubmit(e) {
    e.preventDefault();
    setAlertShow(false);
    setIsLoading(true);
    try {
      const res = await fetchContext.authAxios.post("/submitinvoice", invoice);
      if (res.data.message === 'Session Expired') {
        auth.logout();
      } else if (res.data.message === 'Success') {
        if (typeof setLastAction === "function") {
          setLastAction("submit");
        }
        setSaved();
        invShow();
      } else {
        throw new Error(res.data.message || 'Unexpected server response');
      }
    } catch (error) {
      console.log(error);
      setAlertMsg('There was an error submitting your invoice. Please try again.');
      setAlertVari('danger');
      setAlertShow(true);
    } finally {
      setIsLoading(false);
    }
  }


  function checkDupe(ie) {
    //  console.log("checking dupe")
    var result = Object.values(ie.lineItems
      .filter(v => (v.ProductDetail || "").trim() !== "Consulting Fixed Fee Offset")
      .reduce((c, v) => {
      // if (v.fileName?.length >= 1) {

      //   let k = v.ProductType + '-' + v.fileName;
      //   c[k] = c[k] || [];
      //   c[k].push(v);
      //   return c;
      // }
      // else {

      if (v.ProductType.length > 0) {
        let k = v.ProductType.trim();
        c[k] = c[k] || [];
        c[k].push(v);
        return c;
      }

      return c;
      // }
    }, {})).reduce((c, v) => v.length > 1 ? c.concat(v) : c, []);
    if (result.length >= 1) { setDupeWarn(true) }
    else { setDupeWarn(false) }

    // console.log(result);
  }

  const fetchInvoiceNumbers = async () => {
    try {
      const response = await fetchContext.authAxios.get("/invoice-numbers");
      let data = response.data;
      // If data is an object with invoiceNumbers array
      if (data && Array.isArray(data.invoiceNumbers)) {
        // console.log("Fetched invoice numbers:", data.invoiceNumbers);
        setInvoiceNumbers(data.invoiceNumbers.map(num => String(num).trim()));
      } else if (Array.isArray(data)) {
        setInvoiceNumbers(data.map(num => String(num).trim()));
      } else {
        setInvoiceNumbers([]);
      }
    } catch (error) {
      console.error("Error fetching invoice numbers:", error);
      setInvoiceNumbers([]);
    }
  };


  return (<>

    <Document className="app pdfPadding " pdfMode={pdfMode}>

      <Page className="invoice-wrapper" pdfMode={pdfMode}>
        <View className="flex" pdfMode={pdfMode}>
          <View className="w-50" pdfMode={pdfMode}>

            <Text className='input bold' pdfMode={pdfMode} value={cons.NameFirst + " " + cons.NameLast} >{cons.NameFirst + " " + cons.NameLast}</Text>
            <Text className='input' pdfMode={pdfMode} value={cons.Company} >{cons.Company}</Text>
            <Text className='input' pdfMode={pdfMode} value={cons.Address} >{cons.Address}</Text>
            <Text className='input' pdfMode={pdfMode} value={cons.City + " " + cons.St + " " + cons.Zip} >{cons.City + " " + cons.St + " " + cons.Zip}</Text>
            <Text className='input' pdfMode={pdfMode} value={cons.Phone} >{cons.Phone}</Text>
          </View>

          <View className="w-50" pdfMode={pdfMode}>

            <View className="flex right" pdfMode={pdfMode}>
              <View className={pdfMode ? "w-65 float-right pr-5" : "w-65"} pdfMode={pdfMode}>
                <Text className={`bold invoiceTxt `} pdfMode={pdfMode} >Consultant Invoice #:</Text>
              </View>
              <View className="w-50" pdfMode={pdfMode}>
                <EditableInput
                  aria="Consultant Invoice #"
                  title="Consultant Invoice #"
                  placeholder="Invoice #"
                  value={invoice.ConsultantInvoice} 
                  className={`dark right text-center ${!invoice.ConsultantInvoice || invoice.ConsultantInvoice.length < 3 || invoiceNumberError ? "input-error" : ""}`}
                  onChange={(value) => handleChange('ConsultantInvoice', value)}
                  pdfMode={pdfMode} />
              </View>
            </View>
            {pdfMode ? '' :
              invoiceNumberError ? (<Alert className="text-center" variant="danger">
                This Consultant Invoice # is already used. Please enter a unique number.
              </Alert>) : null}
          </View>
        </View>


        <View className="flex mt-40" pdfMode={pdfMode}>
          <View className="flex" pdfMode={pdfMode}>
            <View className="w-60" pdfMode={pdfMode}>
              <Text className='input bold' pdfMode={pdfMode} value="LRI Consulting Services, Inc." >LRI Consulting Services, Inc.</Text>
              <Text className='input' pdfMode={pdfMode} value="P.O. Box 1529" >P.O. Box 1529</Text>
              <Text className='input' pdfMode={pdfMode} value="Broken Arrow, OK 74013" >Broken Arrow, OK 74013</Text>
              <Text className='input' pdfMode={pdfMode} value="(918) 455-9995" >(918) 455-9995</Text>
            </View>


          </View>

          <View className=" w-100" pdfMode={pdfMode}>
            <View className="invoiceBox w-55 float-end" pdfMode={pdfMode}>

              <Text className='invoiceBoxTitle' value="Client Bill To:" pdfMode={pdfMode} >Client Bill To:</Text>

              <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Name}>{invoice.Name}</Text>
              <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Title}>{invoice.Title}</Text>
              <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Company_Name}>{invoice.Company_Name}</Text>
              <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Address}>{invoice.Address}</Text>
              <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.City + " " + invoice.State + " " + invoice.Zip}>{invoice.City + " " + invoice.State + " " + invoice.Zip}</Text>

            </View>
            <View className="flex mb-5" pdfMode={pdfMode}>
              <View className="w-40" pdfMode={pdfMode}>
                <Text className="bold" pdfMode={pdfMode} />
              </View>
              <View className="w-60" pdfMode={pdfMode}>
              </View>
            </View>
            <View className="flex mb-5" pdfMode={pdfMode}>
              <View className="w-40" pdfMode={pdfMode}>

              </View>
              <View className="w-60" pdfMode={pdfMode}>
              </View>
            </View>
          </View>
        </View>
        <View className=" mt-40 w-55" pdfMode={pdfMode}>
          <Text className='input bold text-center invoiceTxt' pdfMode={pdfMode} value="Dates of Work" >Dates of Work </Text>
          <View className=" flex  text-center  " pdfMode={pdfMode}>
            <View className="flex " pdfMode={pdfMode}>

              <Text className='input   bold invoiceTxt ' pdfMode={pdfMode}   >From: </Text>
              <EditableInput
                required={true}
                type="date"
                calendar={true}
                className={`bold dateinput  ${!invoice.StartDate ? 'input-error' : ''}`}
                value={invoice.StartDate}
                onChange={(value) => handleChange('StartDate', value)}
                pdfMode={pdfMode}
              />
            </View>
            <View className="flex" pdfMode={pdfMode}>
              <Text className='input  bold invoiceTxt ' pdfMode={pdfMode}   >To:</Text>
              <EditableInput
                required={true}
                type="date"
                calendar={true}
                className={`bold dateinput ${!invoice.EndDate ? 'input-error' : ''}`}
                value={invoice.EndDate}
                onChange={(value) => handleChange('EndDate', value)}
                pdfMode={pdfMode}
              />

            </View>
          </View>
        </View>
        <View className="mt-30 bg-dark w-100 flex fs-12 pdfFontSize" pdfMode={pdfMode}>
          <View className="w-5 p-4-8 pdfFontSize" pdfMode={pdfMode}>
            <Text className="white bold" pdfMode={pdfMode}>Qty</Text>
          </View>
          <View className="w-50 p-4-8 pdfFontSize" pdfMode={pdfMode}>
            <Text className="white bold left" pdfMode={pdfMode} >Description of Service or Expense</Text>
          </View>
          {/* <View className="w-17 p-4-8 pdfFontSize" pdfMode={pdfMode}>
            <Text className="white bold center" pdfMode={pdfMode} ></Text>
          </View> */}
          <View className="w-18 p-4-8 pdfFontSize" pdfMode={pdfMode}>
            <Text className="white bold center" pdfMode={pdfMode} >Unit Price</Text>
          </View>
          <View className="w-18 p-4-8 pdfFontSize" pdfMode={pdfMode}>
            <Text className="white bold right" pdfMode={pdfMode} >Amount</Text>
          </View>
        </View>
        {pdfMode ? '' :
          dupewarn ? (<Alert className="text-center" variant="danger">
            There is a duplicate line item. Line items must be unique.
          </Alert>) : null}
        {
          invoice.lineItems.map((lt, i) => (
            pdfMode && lt.ProductType === '' ? (<Text key={i} pdfMode={pdfMode}></Text>) : (
              <View key={i} className="flex rowFocu" pdfMode={pdfMode}>
                {/* {!pdfMode &&
                  (lt.ProductType.length > 0 &&
                    [
                      "consultant - hourly",
                      "consultant - daily",
                      "consultant rate",
                      "per diem",
                      "per diem - travel day",
                      "per diem - other days",
                      "per diem - modified",
                      "mileage",
                      "travel fee",
                      "",
                      "select product or service"
                    ].includes(lt.ProductType.toLowerCase())
                    ? ''
                    : (
                      <ImageModal
                        info={lt}
                        onUpload={(value) => {
                          handleProductLineChange(i, 'file', value)
                        }}
                      />
                    )
                  )
                } */}
                {!pdfMode && (() => {
                  const excluded = new Set([
                    "consultant - hourly",
                    "consultant - daily",
                    "consultant rate",
                    "per diem",
                    "per diem - travel day",
                    "per diem - other days",
                    "per diem - modified",
                    "mileage",
                    "travel fee",
                    "",
                    "select product or service"
                  ]);

                  const pt = (lt?.ProductType ?? "").trim().toLowerCase();

                  // Only render AFTER a real selection that isn't excluded
                  return pt && !excluded.has(pt) ? (
                    <ImageModal
                      info={lt}
                      onUpload={(value) => {
                        handleProductLineChange(i, "file", value);
                      }}
                    />
                  ) : null;
                })()}

                <View className="w-5 p-4-8 pb-10 pdfFontSize" pdfMode={pdfMode}>
                  <EditableInput type="number" aria="Qty" title="Qty" placeholder="Qty" value={lt.quantity} className="dark right text-start" onChange={(value) => handleProductLineChange(i, 'quantity', value)} pdfMode={pdfMode} />
                </View>
                <View className="w-50 pt-1  pb-10 pdfFontSize" pdfMode={pdfMode}>
                  {/* {console.log(lt.description)} */}
                  {/* <EditableInput type="select" className="dark"  placeholder="Enter item name/description" value={lts.description} onChange={(value) => handleProductLineChange(i, 'description', value)} pdfMode={pdfMode} /> */}
                  <EditableSelect placeholder="Select Product or Service" options={descriptions} disabled={lt.ProductDetail === "Consulting Fixed Fee Offset"} onChange={(value) => { handleProductLineChange(i, 'ProductType', value); }} value={lt.ProductType} pdfMode={pdfMode} />

                  <EditableInput
                    // placeholder is safe even if `descripts` or the match is missing
                    placeholder={descripts?.find(d => d.value === lt.ProductType)?.placeholder ?? null}
                    required={descripts?.find(d => d.value === lt.ProductType)?.required ?? false}
                    readOnly={lt.ProductDetail === "Consulting Fixed Fee Offset"}
                    // keep the input controlled even if ProductDetail is undefined/null
                    value={lt.ProductDetail ?? null}

                    // only show error style when detail is actually required AND too short
                    className={`dark pdfFontSize ${(descripts?.find(d => d.value === lt.ProductType)?.required ?? isDetailRequired(lt.ProductType)) &&
                        (!lt.ProductDetail || lt.ProductDetail.trim().length < 2) &&
                        lt.ProductDetail !== "Reciept Required"
                        ? "input-error"
                        : ""
                      }`}

                    // IMPORTANT: keep this input in edit mode so it actually renders as an input
                    pdfMode={false}

                    onChange={(value) => {
                      handleProductLineChange(i, "ProductDetail", value);
                    }}
                  />


                </View>

                {/* <View className="w-18 p-4-8 pb-10 pdfFontSize" pdfMode={pdfMode}>
                  <EditableInput placeholder="" className="dark center noHover" aria="Rate" title="Rate" readOnly={true} value={lt.unit} onChange={(value) => handleProductLineChange(i, 'unit', value)} pdfMode={pdfMode} />
                </View> */}
                <View className="w-17 p-4-8 pb-10 pdfFontSize" pdfMode={pdfMode}>

                  <EditableInput
                    className={`dark right center pdfFontSize ${!lt.rate ? 'input-error' : ''}`}
                    aria="Price"
                    title="Price"
                    placeholder="Rate"
                    readOnly={lt.ProductType === 'Consultant Rate' ? true : false}
                    value={"$" + lt.rate}
                    onChange={(value) => handleProductLineChange(i, 'rate', value)}
                    onBlur={(value) => handleFormat(i, 'rate', value)}
                    pdfMode={pdfMode}
                  >
                    {lt.rate}
                  </EditableInput>
                </View>


                <View className="w-18 p-1 pb-10 pdfFontSize" pdfMode={pdfMode}>
                  <Text className="dark right" pdfMode={pdfMode} >
                    {calculateAmount(lt.quantity, lt.rate)}
                  </Text>
                </View>
                {!pdfMode && lt.ProductDetail !== "Consulting Fixed Fee Offset" && (<button className="link row__remove" aria-label="Remove Line Item" title="Remove Line Item" onClick={() => handleRemove(i)}>
                  <span className="icon icon-remove bg-red"></span>
                </button>)}

              </View>
            ))
          )}

        {/* // ) : ("")} */}
        <View className='row' pdfMode={pdfMode}>
          <View className="col  " pdfMode={pdfMode}>
            <View className="w-70 mt-10" pdfMode={pdfMode}>
              {!pdfMode && (<Button variant="white" className='link bg-white' onClick={() => handleAdd()}>
                <span className="iconAdd icon-add bg-green mr-10"></span>
                Add Line Item
              </Button>)}
            </View>
          </View>
          <View className="col  " pdfMode={pdfMode}>
            <View className="w-25 mt-10 float-end" pdfMode={pdfMode}>

              <Text className=" bold right px-1" pdfMode={pdfMode} >Total</Text>

              <EditableInput className="right totalBox" readOnly={true} value={invoice.subTotal} placeholder="Total" onChange={(value) => handleChange('in', value)} pdfMode={pdfMode} />
            </View>
          </View>
        </View>



        <View className=" text-center left">
          <View className="row">
            <View className="col">
              <View className="" pdfMode={pdfMode}>

                <View className="row justify-content-center text-center">
                  <View className="row d-block ">
                    <View className="w-50 mt-10 bold locationLable" pdfMode={pdfMode}>
                      <Text className="text-center">Locations</Text>
                    </View>
                    <View className="locationContainer">
                      {invoice.locations.map((loc, i) => (

                        <View key={i} className="flex rowFocu " pdfMode={pdfMode}>
                          <View className="flex" pdfMode={pdfMode}>
                            <Text className="w-10">{i + 1}</Text>
                            <EditableInput className="dark w-70  center" placeholder="City" value={invoice.locations[i].city} readOnly={false} onChange={(value) => handleLocationChange(i, 'city', value)} pdfMode={pdfMode} />
                            <EditableInput className="dark w-30 flex center" maxLength={2} placeholder="State" value={invoice.locations[i].state} readOnly={false} onChange={(value) => handleLocationChange(i, 'state', value)} pdfMode={pdfMode} />
                          </View>
                          {!pdfMode && (<button className="link row__remove" aria-label="Remove Row" title="Remove Row" onClick={() => handleRemoveLoc(i)}>
                            <span className="iconLoc icon-remove bg-red"></span>
                          </button>)}
                        </View>
                      ))
                      }

                    </View>
                    {invoice.locations.length <= 7 ? (!pdfMode && (<View className='row w-50'> <Button variant="white" className='bg-white link' onClick={() => handleAddLoc()}>
                      <span className="iconAdd icon-add bg-green mr-10"></span>
                      Add Location
                    </Button></View>)) : null}

                  </View>
                  <View className=" flex">
                    <View className="w-70 mt-10 bold row" pdfMode={pdfMode}>
                      <Text className="text-center px-5 locationLable notes ">Notes</Text>
                      <EditableTextarea className="w-100  notesBox" rows={3} value={invoice.notes} onChange={(value) => handleChange('notes', value)} pdfMode={pdfMode} />
                    </View>
                    <View className="w-30 mt-10 bold " pdfMode={pdfMode}>
                      <Text className="text-center mb-0 ">Reportable</Text>
                      <EditableSelect className={`w-100  notesBox  ${!invoice.Reportable || invoice.Reportable.length < 1 ? "input-error" : ""}`} options={reportable} value={invoice.Reportable} onChange={(value) => handleChange('Reportable', value)} pdfMode={pdfMode} />
                    </View>
                  </View>
                </View>
              </View>
            </View>


          </View>
        </View>
      </Page>
      {pdfMode ? null : (
        <Container>
          <Row className="justify-content-center mt-3 d-flex">
            <Row>
              {checkForm("draft") ? (
                <p className="text-danger text-center">
                  Please fill in all required fields: <strong>Dates Worked, Invoice #, Line Items, and Reportable. <br /> Each description field must contain at least 3 characters</strong> to save or submit your invoice.
                  <br />To submit, you’ll also need to provide a <strong>Location</strong>.
                </p>
              ) : checkForm("submit") ? (
                <p className="text-danger text-center">
                  You can <strong>save a draft</strong> now. To <strong>submit</strong>, please add a <strong>Location</strong>.
                </p>
              ) : null}
            </Row>

            {alertShow && (
              <Alert variant={alertVari} onClose={() => setAlertShow(false)} dismissible className="text-center w-100">
                {alertMsg}
              </Alert>
            )}

            {!btnSelect ? null : (
              <>
                <Col sm className="justify-content-center d-flex my-2">
                  {!pdfMode && (
                    <Confirm
                      headingTxt="Save Draft Confirmation"
                      disabled={checkForm("draft")}
                      onConfirm={(e) => handleDraft(e)}
                      bodyMsg={`Confirm you want to save a draft invoice for ${invoice.Company_Name}.`}
                      action="Save Draft"
                      vari="success"
                    />
                  )}
                </Col>

                <Col sm className="justify-content-center d-flex my-2">
                  {!pdfMode && (
                    <Confirm
                      headingTxt="Submit Invoice Confirmation"
                      disabled={checkForm("submit")}
                      onConfirm={(e) => handleSubmit(e)}
                      bodyMsg={`Confirm you want to submit an invoice for ${invoice.Company_Name}. You will not be able to edit this invoice later.`}
                      action="Submit Invoice"
                      vari="primary"
                    />
                  )}
                </Col>
              </>
            )}
          </Row>
        </Container>
      )}

    </Document>


  </>


  )
}


export default Invoice